module.exports = __webpack_public_path__ + "static/media/react1Var.afc0ee63.png";